import { Component, Input, OnInit } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-lottie-plane',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './lottie-plane.component.html',
  styleUrl: './lottie-plane.component.css',
})
export class LottiePlaneComponent implements OnInit {
  @Input() name: string = 'plane';

  playAnimation: boolean = false;
  options: AnimationOptions = {
    path: `lottie/plane.json`,
  };

  ngOnInit() {
    this.options = {
      path: `lottie/${this.name}.json`,
    };
  }

  animationCreated(animationItem: AnimationItem): void {
    if (this.playAnimation) {
      animationItem.play();
    }
  }
}
